import { Form } from "antd";

import { SeverityFieldNames } from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/constants";
import {
  getDefectsFromMaterials,
  useReferentialMaterials,
} from "@/entities/referential/referential-materials";

const { useFormInstance, useWatch } = Form;

export const useDefectsFromReferential = () => {
  const form = useFormInstance();
  const selectedMaterial = useWatch(SeverityFieldNames.material, form);
  const { isLoading, materials } = useReferentialMaterials();
  const refMaterials = materials ?? [];

  const defects =
    refMaterials.find(({ slug }) => slug === selectedMaterial)?.defects ??
    getDefectsFromMaterials(refMaterials);

  return {
    isLoadingReferential: isLoading ?? false,
    defects,
  };
};
